import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Breadcrumb that leads back to where the page was opened from (2026-10-13).
// Callers navigate with { state: { from: 'home' } } or
// { state: { from: { path, label } } }; otherwise the page's fallback is used.
// The origin is captured on first render so saves that rewrite the URL
// (e.g. dropping ?created=1) don't lose it.
export function useBackTarget({ home, fallback }) {
  const location = useLocation();
  const [from] = useState(() => location.state?.from);
  if (from === 'home' && home) return { path: '/', label: home };
  if (from && typeof from === 'object' && from.path && from.label) return from;
  return fallback;
}

export function fromHere(path, label) {
  return { state: { from: { path, label } } };
}

export default function BackCrumb({ to }) {
  const navigate = useNavigate();
  if (!to) return null;
  return <a onClick={() => navigate(to.path)} style={{ cursor: 'pointer' }}>{to.label}</a>;
}
